// Nail Collective — scroll reveal + small UI helpers.
// Pure vanilla, no dependencies. See BRAND.md for motion spec.

(function () {
  if (typeof window === 'undefined') return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = !!(window.Shopify && window.Shopify.designMode);

  // --- Scroll-reveal ------------------------------------------------------
  function revealAll(root) {
    (root || document).querySelectorAll('.nc-reveal:not(.is-visible)').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function initReveal() {
    const els = document.querySelectorAll('.nc-reveal');
    if (!els.length) return;

    // In the Shopify theme editor, always reveal immediately.
    // The editor re-renders sections in place after each setting change;
    // an IntersectionObserver bound on first load won't catch the new nodes.
    if (prefersReducedMotion || inEditor || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          const delay = entry.target.dataset.revealDelay;
          if (delay) entry.target.style.transitionDelay = delay + 'ms';
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  // --- Marquee pause on hover (scent strip etc.) -------------------------
  function initMarquee() {
    if (prefersReducedMotion) {
      document.querySelectorAll('.nc-marquee').forEach(function (el) {
        el.classList.add('nc-marquee--paused');
      });
    }
  }

  // --- Testimonial slider: scroll-snap track + auto-advance --------------
  function initTestimonialSlider(root) {
    (root || document).querySelectorAll('.nc-tslider').forEach(function (el) {
      if (el.dataset.tsliderInit) return;
      el.dataset.tsliderInit = 'true';

      const track = el.querySelector('.nc-tslider__track');
      if (!track) return;

      const prevBtn = el.querySelector('.nc-tslider__arrow--prev');
      const nextBtn = el.querySelector('.nc-tslider__arrow--next');

      let overflowing = false;
      let timer = null;
      let scrollResetTimeout = null;

      function updateOverflow() {
        overflowing = track.scrollWidth > track.clientWidth + 1;
        track.classList.toggle('nc-tslider__track--fade', overflowing);
      }

      function cardStep() {
        const card = track.querySelector('.nc-testimonial');
        if (!card) return track.clientWidth;
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function advance() {
        const step = cardStep();
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - step / 2) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step, behavior: 'smooth' });
        }
      }

      function retreat() {
        const step = cardStep();
        if (track.scrollLeft <= step / 2) {
          track.scrollTo({ left: track.scrollWidth - track.clientWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -step, behavior: 'smooth' });
        }
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startTimer() {
        stopTimer();
        // Never auto-advance with reduced motion, while actively editing in the
        // customizer, or when every card already fits on screen.
        if (prefersReducedMotion || inEditor || !overflowing) return;
        const interval = parseInt(el.dataset.interval, 10) || 7000;
        timer = setInterval(function () {
          if (el.matches(':hover') || document.hidden || el.contains(document.activeElement)) return;
          advance();
        }, interval);
      }

      if (nextBtn) nextBtn.addEventListener('click', advance);
      if (prevBtn) prevBtn.addEventListener('click', retreat);

      track.addEventListener('scroll', function () {
        updateOverflow();
        clearTimeout(scrollResetTimeout);
        scrollResetTimeout = setTimeout(startTimer, 4000);
      });

      updateOverflow();
      startTimer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initMarquee();
      initTestimonialSlider();
    });
  } else {
    initReveal();
    initMarquee();
    initTestimonialSlider();
  }

  // --- Shopify editor: re-reveal on section/block reload -----------------
  // When Tayla edits a setting, Shopify fires these events on the re-rendered node.
  if (inEditor) {
    ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        revealAll(e.target);
        initMarquee();
        if (ev === 'shopify:section:load') {
          initTestimonialSlider(e.target);
        }
      });
    });
  }
})();
